import axios from "axios";
import filter from "lodash/filter";
import { useEffect, useState } from "react";
import useSWR from "swr";
import AxiosConfigure from "../Axios.configure";

const UseFetchSellerStore = (fulldata) => {
  const [datam, setdatam] = useState([]);
  const fetcher = async () => {
    const SellerData = await axios.get(
      `https://hs.nakroteck.biz/api/branches`
    );
    const AddressData = await axios.get(
      `https://hs.nakroteck.biz/api/branches`
    );

    return AddressData.data.data;
  };
  const { data, error, mutate } = useSWR(
    datam.length ? null : "getSellerCompany",
    fetcher
  );
  useEffect(() => {
    if (data && !error && !datam.length) {
      setdatam(data);
    }
  }, [data, error,datam]);
  if (fulldata) {
    return {
      data: datam,
      isLoading: !error && !datam.length,
      isError: error,
      mutate,
    };
  }
  if (!AxiosConfigure.getSelectedBranch() && datam.length) {
    AxiosConfigure.setSelectedBranch(datam[0]);
    return {
      data: datam[0],
      isLoading: !error && !datam.length,
      isError: error,
      mutate,
    };
  } else {
    return {
      data: AxiosConfigure.getSelectedBranch(),
      isLoading: !error && !datam.length,
      isError: error,
      mutate,
    };
  }
};

export default UseFetchSellerStore;
